import { makeAutoObservable } from 'mobx';
import { Element } from '../types';
import type { RootStore } from './RootStore';

type Snapshot = string; // JSON string of Element[]

export class HistoryStore {
  rootStore!: RootStore;
  undoStack: Snapshot[] = [];
  redoStack: Snapshot[] = [];

  constructor() {
    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  init(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  addSnapshot(snapshot: Snapshot) {
    this.undoStack.push(snapshot);
    this.redoStack = []; // Clear redo stack on new action
  }

  undo() {
    if (this.undoStack.length > 0) {
      const snapshotToRestore = this.undoStack.pop()!;

      const currentSnapshot = JSON.stringify(
        this.rootStore.projectStore.elements
      );
      this.redoStack.push(currentSnapshot);

      const elements: Element[] = JSON.parse(snapshotToRestore);
      this.rootStore.projectStore.loadElements(elements);
    }
  }

  redo() {
    if (this.redoStack.length > 0) {
      const snapshotToRestore = this.redoStack.pop()!;

      const currentSnapshot = JSON.stringify(
        this.rootStore.projectStore.elements
      );
      this.undoStack.push(currentSnapshot);

      const elements: Element[] = JSON.parse(snapshotToRestore);
      this.rootStore.projectStore.loadElements(elements);
    }
  }
}
